"use client";

const MG_PATH =
  "M139.7 203.0 L131.1 207.5 L121.1 202.1 L118.9 203.4 L100.8 201.4 L96.5 204.4 L91.7 204.8 L86.4 211.8 L82.9 208.5 L73.1 212.0 L65.8 210.7 L64.2 212.9 L58.2 213.3 L51.8 220.8 L49.8 226.4 L43.6 229.1 L40.6 233.0 L39.1 236.6 L40.7 238.1 L37.2 238.0 L37.4 241.8 L34.0 245.0 L35.2 257.4 L52.4 248.0 L56.1 250.6 L65.3 252.1 L90.3 253.8 L88.5 258.4 L90.0 262.9 L92.4 264.6 L96.1 259.6 L98.6 260.1 L99.3 267.4 L101.7 268.5 L103.8 259.8 L122.8 258.8 L123.2 256.2 L127.2 259.4 L130.2 255.9 L132.8 258.7 L134.3 254.4 L141.0 256.2 L145.7 253.8 L153.9 261.6 L151.9 267.9 L156.6 271.8 L157.9 276.2 L155.3 277.8 L154.0 281.7 L160.8 299.5 L168.5 297.5 L176.6 301.6 L170.9 312.6 L173.2 317.5 L170.0 320.3 L173.8 322.0 L169.8 327.3 L178.2 334.1 L180.2 338.6 L177.7 339.9 L182.1 341.8 L181.7 346.2 L196.7 345.1 L201.7 341.9 L198.7 340.9 L202.7 335.7 L203.1 338.2 L209.0 336.3 L211.5 338.3 L220.2 333.3 L234.7 329.7 L241.2 325.8 L247.4 326.1 L263.0 319.7 L273.3 319.6 L276.1 317.8 L282.9 318.6 L282.6 321.0 L310.1 308.7 L307.4 304.8 L310.5 301.5 L312.4 291.3 L316.0 287.2 L313.8 285.4 L319.3 284.2 L322.5 278.8 L324.8 269.7 L323.0 266.5 L326.2 261.2 L337.0 261.2 L340.6 252.8 L344.1 251.3 L344.7 244.4 L350.9 239.2 L351.1 227.1 L348.1 225.0 L348.0 221.5 L342.4 218.6 L342.7 216.9 L352.6 217.4 L351.9 213.5 L348.4 211.7 L349.3 206.2 L344.3 205.6 L345.0 201.5 L348.4 197.0 L357.1 195.2 L353.1 191.3 L356.4 190.4 L360.7 192.2 L364.9 188.4 L374.5 191.1 L374.4 183.4 L368.4 179.5 L362.5 171.5 L364.2 169.2 L363.3 165.0 L366.0 156.7 L372.6 157.2 L372.8 146.9 L376.5 147.0 L378.0 142.9 L384.1 137.8 L386.0 132.4 L384.2 128.8 L381.4 128.9 L374.1 122.6 L365.1 122.4 L359.4 118.3 L357.3 119.8 L355.8 117.7 L345.5 121.6 L339.6 120.7 L338.6 112.9 L324.8 100.5 L320.0 102.9 L313.1 100.0 L310.2 101.3 L289.0 88.1 L281.5 86.3 L277.3 86.9 L270.3 91.5 L259.2 86.4 L262.4 76.5 L256.5 74.5 L246.3 73.8 L238.0 76.5 L229.3 81.6 L228.0 84.7 L221.1 89.5 L217.6 89.3 L200.8 101.1 L193.5 102.2 L190.2 105.7 L193.7 96.2 L191.4 93.4 L187.0 95.7 L182.6 94.2 L182.5 91.5 L176.8 88.0 L175.0 91.5 L176.8 98.9 L172.9 100.1 L165.6 97.6 L163.5 99.1 L163.1 103.8 L165.9 109.1 L163.3 111.3 L162.8 115.1 L164.8 116.5 L167.2 124.7 L156.8 126.5 L151.4 129.9 L151.0 135.4 L146.8 143.4 L148.1 146.9 L154.0 151.5 L154.6 156.3 L157.1 159.6 L145.0 170.6 L144.2 174.7 L152.8 179.5 L149.4 186.5 L152.2 193.1 L142.0 199.5 L139.7 203.0 Z";
const UDI_PATH =
  "M127.7 219.7 L126.1 218.3 L126.2 217.5 L124.9 217.4 L124.3 216.2 L122.7 215.6 L121.5 216.2 L121.4 215.0 L119.9 214.6 L119.3 212.0 L117.2 211.7 L115.8 212.5 L114.2 210.6 L113.4 210.5 L112.8 211.6 L113.5 212.4 L113.7 214.9 L114.0 215.6 L112.2 216.6 L111.9 217.7 L110.7 218.2 L112.2 219.9 L113.2 220.2 L112.7 222.2 L111.6 223.1 L109.8 221.8 L109.4 222.9 L108.4 223.8 L107.4 225.6 L105.7 225.6 L103.7 226.5 L106.8 228.9 L108.5 229.2 L109.3 229.8 L111.6 230.5 L115.0 233.6 L114.6 234.1 L115.8 235.6 L117.1 236.2 L118.5 236.2 L118.7 234.8 L119.9 232.2 L121.2 230.7 L122.6 230.1 L122.4 229.2 L124.9 228.2 L126.8 230.0 L126.8 230.8 L129.5 231.2 L130.0 233.0 L130.9 233.9 L131.3 232.5 L132.7 231.6 L132.7 229.9 L132.1 227.5 L132.4 226.3 L131.8 225.4 L131.0 225.4 L130.3 223.3 L129.4 222.4 L129.0 220.6 L127.7 219.7 Z";
const UDI_POINT = { x: 120.9, y: 220.7 };

export function UberlandiaMap() {
  const markerStyle = {
    left: `${(UDI_POINT.x / 420) * 100}%`,
    top: `${(UDI_POINT.y / 420) * 100}%`,
  };

  return (
    <div className="udi-map-wrap" aria-label="Mapa estilizado de Minas Gerais com destaque em Uberlandia">
      <svg
        className="udi-map-svg"
        viewBox="0 0 420 420"
        role="img"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <radialGradient id="udi-map-glow" cx="36%" cy="52%" r="58%">
            <stop offset="0%" stopColor="rgba(234, 179, 8, 0.32)" />
            <stop offset="52%" stopColor="rgba(234, 179, 8, 0.12)" />
            <stop offset="100%" stopColor="rgba(234, 179, 8, 0)" />
          </radialGradient>
          <filter id="udi-map-soft-shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="18" stdDeviation="18" floodColor="rgba(15, 23, 42, 0.16)" />
          </filter>
        </defs>

        <path className="udi-map-glow" d={MG_PATH} fill="url(#udi-map-glow)" />

        <path
          className="udi-map-state-fill"
          filter="url(#udi-map-soft-shadow)"
          d={MG_PATH}
        />
        <path className="udi-map-state-line" d={MG_PATH} />

        <circle className="udi-map-city-halo" cx={UDI_POINT.x} cy={UDI_POINT.y} r="38" />
        <path className="udi-map-region-fill" d={UDI_PATH} />
        <path className="udi-map-region-line" d={UDI_PATH} />

        <g className="udi-map-roads">
          <path d="M82 210 C142 236 209 270 303 310" />
          <path d="M54 248 C131 233 222 215 349 197" />
          <path d="M177 340 C183 269 215 178 262 76" />
        </g>
      </svg>

      <div className="udi-marker" aria-hidden="true" style={markerStyle}>
        <span className="udi-marker-ring" />
        <span className="udi-marker-ring udi-marker-ring-delay" />
        <span className="udi-marker-dot" />
      </div>

      <div className="uber-badge">
        <div className="uber-badge-dot" />
        Uberlandia, MG - Polo de Inovacao
      </div>
    </div>
  );
}
